var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_1503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 37.5H39V35C39 31.5483 41.7982 28.75 45.25 28.75H52.75C56.2017 28.75 59 31.5483 59 35V37.5ZM49 26.25C44.8579 26.25 41.5 22.8921 41.5 18.75C41.5 14.6079 44.8579 11.25 49 11.25C53.1421 11.25 56.5 14.6079 56.5 18.75C56.5 22.8921 53.1421 26.25 49 26.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(34 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFilled);
export default __webpack_public_path__ + "static/media/profile-filled.70b56163370a210b8df005c6fc8d964c.svg";
export { ForwardRef as ReactComponent };